import type { Theme } from '@mui/material/styles';
import { getOpenXAgentGradient } from '../colors.ts';

export const getButtonStyles = (theme: Theme) => ({
  position: 'fixed',
  right: 24,
  bottom: 24,
  background: getOpenXAgentGradient(theme),
  width: 64,
  height: 64,
  zIndex: 1000,
  borderRadius: '50%',
  pointerEvents: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: 0.75,
  cursor: 'pointer',
});
